const LugosiAlbumsStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static"> 

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/4bmAxOqy4cyxgtzmShtiBv?si=QoBgRQxVQseY4h5ueHUDYg" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02992faa6abe177a9941899ce9" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>HELLBORNE</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/1oJT2KRgPNEf3Nzn0567o4?si=iXfj5ePKQv2kZcGB3IVeMA" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b27335b7903e635582c019f3e082" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>DYING ON THE EAST COAST</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/7mygx4N05Il50UcBbLPI4V?si=8JXBdqaBSB6Jkz3JR8J0cw" target="_blank" rel="noopener noreferrer">
              <img src="https://i.scdn.co/image/ab67616d0000b273f2f2bf001f382b16315b7ac3" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Kawaii Ry & Lugosi - Bimmy Boys</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://soundcloud.com/lillugosi/sets/lugosi" target="_blank" rel="noopener noreferrer">
              <img src="https://i1.sndcdn.com/artworks-ruOlwPoeh82e49kX-2vdXvg-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>LUGOSI</strong><br/>
              </p>
            </a>
          </div>                                                                                                                               
        
        </div>
      </>
    );
  };
  export default LugosiAlbumsStatic;